export default __webpack_public_path__ + "static/media/ibc.c62037c8.gif";